export default __webpack_public_path__ + "static/media/upload_video.fe69480a.svg";